// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5f6b7a1a","498":"8c7f5c60","513":"489e0fb4","787":"cda612ba"}[chunkId] + ".chunk.js";
};